// 📡 artistQuoteService.js
import { supabase } from '../lib/supabaseClient.js';

export async function fetchArtistQuote(artistName) {
  const { data, error } = await supabase
    .from('artist_quotes')
    .select('*')
    .eq('artist', artistName);

  if (error) {
    console.error('Erreur récupération quote artiste :', error);
    return null;
  }
  return data;
}

export async function fetchArtistQuoteByMedium(artistName, medium) {
  const { data, error } = await supabase
    .from('artist_quotes')
    .select('*')
    .eq('artist', artistName)
    .eq('medium', medium)
    .single();

  if (error) {
    console.error('Erreur récupération quote par médium :', error);
    return null;
  }
  return data;
}

export async function fetchHistoricalPrices(artistName, medium) {
  const { data, error } = await supabase
    .from('artist_quote_history')
    .select('month, average_value')
    .eq('artist', artistName)
    .eq('medium', medium)
    .order('month', { ascending: true });

  if (error) {
    console.error('Erreur récupération historique de prix :', error);
    return [];
  }
  return data;
}

export async function recalculateArtistQuote() {
  const { data, error } = await supabase.rpc('refresh_artist_quotes');

  if (error) {
    console.error('Erreur lors du recalcul de la cote artiste :', error);
    return null;
  }
  return data;
}
